import { gql } from "@/__generated__/gql";

export const TEAMMATES_BY_ROLE = gql(`
  query Teammates(
    $orgId: ID!
    $roles: [UserRoleEnum!]!
    $first: Int
    $last: Int
    $after: String
    $before: String
    $imageSize: Int!
    $ordering: [UserOrderingInput!]!
    $omissions: [UserOmissionAttributeEnum!]
  ) {
    node(id: $orgId) {
        ... on Organization {
        id
        users(
          first: $first
          after: $after
          roles: $roles
          ordering: $ordering
          before: $before
          last: $last
          omissions: $omissions
        ) {
          edges {
            node {
              id
              uuid
              email
              firstName
              isDefaultCounselor(organizationId: $orgId)
              isSuperCounselor(organizationId: $orgId)
              lastName
              lastActiveAt
              name @client
              phoneNumber
              role
              profilePhoto {
                id
                url(size: $imageSize)
              }
            }
            cursor
          }
          pageInfo {
            hasPreviousPage
            startCursor
            endCursor
            hasNextPage
          }
          totalCount
        }
      }
    }
  }
`);
